// extracted by mini-css-extract-plugin
export default {"container":"FileUploadingModal_container__zygOy","loader":"FileUploadingModal_loader__WNFOj"};